import calculate from './calculate';
import { calculateGrowth } from './utils';
import calculatePortfolioRiskMetrics from './risk-metrics';

export default { calculateGrowth, calculate, calculatePortfolioRiskMetrics };
